export const ADELPHI_CASKS_TARGETS = {
  ADELPHI_CASK_FILLINGS: 'adelphiCaskFillings',
  ADELPHI_CASK_FILLING_BY_ID: 'adelphiCaskFillingById',
  CREATE_ADELPHI_CASKS_OF_EXCEL: 'createAdelphiCasksOfExcel',
  CURRENT_ADELPHI_CASK_FILLING: 'currentAdelphiCaskFilling'
};

export const ADELPHI_CASKS_DEFAULT_STATE = {
  [ADELPHI_CASKS_TARGETS.ADELPHI_CASK_FILLINGS]: [],
  [ADELPHI_CASKS_TARGETS.ADELPHI_CASK_FILLING_BY_ID]: {},
  [ADELPHI_CASKS_TARGETS.CREATE_ADELPHI_CASKS_OF_EXCEL]: null,
  [ADELPHI_CASKS_TARGETS.CURRENT_ADELPHI_CASK_FILLING]: null
};
